import { DataTable } from "primereact/datatable";
import React from "react";
import "./DataTableGrid.scss";

function DataTableGrid({ children, data, isSearch, frozenValue,resetKey, onColumnResizeEnd, storeReorderedColumns,selected }) {
  return (
    <>
      <DataTable
        value={data}
        scrollable
        stripedRows
        showGridlines
        size={"small"}
        resizableColumns
        reorderableColumns
        rows={50}
        paginator={data?.length}
        paginatorPosition="top"
        frozenValue={frozenValue}
        tableStyle={{ width: "max-content", minWidth: "100%"}}
        filterDisplay={isSearch && "row"}
        rowClassName={(rowData) =>selected?.some(item=>item.UniqueID===rowData[0].UniqueID)
            ? "highlight-row-planning"
            : rowData[0]?.isDraft
            ? "highlight-row-draft-planning"
            : ""
        }
        key={resetKey}
        onColumnResizeEnd={onColumnResizeEnd}
        onColReorder={storeReorderedColumns}
        columnResizeMode="expand"
      >
        {children}
      </DataTable>
    </>
  );
}

export default DataTableGrid;
